import type { LeadFilters } from '../../api/endpoints';

export const sortOptions = [
  { value: 'created_at', label: 'Neueste zuerst' },
  { value: 'updated_at', label: 'Zuletzt geändert' },
  { value: 'next_contact_at', label: 'Nächster Kontakt' },
  { value: 'last_contact_at', label: 'Letzter Kontakt' },
  { value: 'postal_code', label: 'Postleitzahl' },
  { value: 'company_name', label: 'Firmenname' },
];

export const filterKeys: (keyof LeadFilters)[] = [
  'q', 'status', 'geo_status', 'data_quality', 'postal_code', 'federal_state_id', 'county_id', 'area_id', 'assigned_user_id',
  'assigned_field_sales_user_id', 'has_appointment', 'has_follow_up', 'next_contact_from', 'next_contact_to',
  'last_contact_from', 'last_contact_to', 'created_from', 'created_to', 'sort', 'order',
];

const multiKeys = new Set<keyof LeadFilters>(['status', 'geo_status', 'data_quality']);

// readFilters liest die Filter aus der URL; so sind gefilterte Listen verlinkbar (z. B. aus den Regionen).
export function readFilters(params: URLSearchParams): LeadFilters {
  const out: Record<string, string | string[]> = {};
  for (const key of filterKeys) {
    if (multiKeys.has(key)) {
      const values = params.getAll(key).filter(Boolean);
      if (values.length) out[key] = values;
    } else {
      const value = params.get(key);
      if (value) out[key] = value;
    }
  }
  return out as LeadFilters;
}

// hasActiveFilters ignoriert die reine Sortierung.
export function hasActiveFilters(filters: LeadFilters): boolean {
  return filterKeys.some((k) => k !== 'sort' && k !== 'order' && filters[k] !== undefined);
}
